import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import OpeningsPage from './pages/OpeningsPage';
import OpeningDetailPage from './pages/OpeningDetailPage';
import StudyPage from './pages/StudyPage';
import ProfilePage from './pages/ProfilePage';
import PathwayPage from './pages/PathwayPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

// Browsing the catalog and reading theory are public; only per-user progress
// sits behind ProtectedRoute. StudyPage handles the signed-out case itself so
// it can explain why an account is needed rather than bouncing to /login.
const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  { path: '/openings', element: <OpeningsPage /> },
  { path: '/openings/:openingId', element: <OpeningDetailPage /> },
  { path: '/study', element: <StudyPage /> },
  { path: '/pathway', element: <ProtectedRoute><PathwayPage /></ProtectedRoute> },
  { path: '/profile', element: <ProtectedRoute><ProfilePage /></ProtectedRoute> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '*', element: <HomePage /> },
]);

export default function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </AuthProvider>
  );
}
